// Copyright 2020 Northern.tech AS
//
//    Licensed under the Apache License, Version 2.0 (the "License");
//    you may not use this file except in compliance with the License.
//    You may obtain a copy of the License at
//
//        http://www.apache.org/licenses/LICENSE-2.0
//
//    Unless required by applicable law or agreed to in writing, software
//    distributed under the License is distributed on an "AS IS" BASIS,
//    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//    See the License for the specific language governing permissions and
//    limitations under the License.
export const onboardingSteps = {
  DEVICES_PENDING_ONBOARDING_START: 'devices-pending-onboarding-start',
  DASHBOARD_ONBOARDING_START: 'dashboard-onboarding-start',
  DASHBOARD_ONBOARDING_PENDINGS: 'dashboard-onboarding-pendings',
  DEVICES_DELAYED_ONBOARDING: 'devices-delayed-onboarding',
  DEVICES_PENDING_ONBOARDING: 'devices-pending-onboarding',
  DEVICES_ACCEPTED_ONBOARDING: 'devices-accepted-onboarding',
  DEVICES_PENDING_ACCEPTING_ONBOARDING: 'devices-pending-accepting-onboarding',
  DEVICES_DEPLOY_RELEASE_ONBOARDING: 'devices-deploy-release-onboarding',
  DEVICES_DEPLOY_RELEASE_ONBOARDING_STEP_2: 'devices-deploy-release-onboarding-step-2',
  SCHEDULING_ARTIFACT_SELECTION: 'scheduling-artifact-selection',
  SCHEDULING_ALL_DEVICES_SELECTION: 'scheduling-all-devices-selection',
  SCHEDULING_GROUP_SELECTION: 'scheduling-group-selection',
  SCHEDULING_RELEASE_TO_DEVICES: 'scheduling-release-to-devices',
  DEPLOYMENTS_INPROGRESS: 'deployments-inprogress',
  DEPLOYMENTS_PAST: 'deployments-past',
  DEPLOYMENTS_PAST_COMPLETED: 'deployments-past-completed',
  DEPLOYMENTS_PAST_COMPLETED_FAILURE: 'deployments-past-completed-failure',
  ONBOARDING_CANCELED: 'onboarding-canceled'
};
